var map = {
	"./carbon-icon.svg": 1580,
	"./dff-icon.svg": 149,
	"./ffb-icon.svg": 112,
	"./fff-icon.svg": 150,
	"./ffi-icon.svg": 113,
	"./gef-icon.svg": 151,
	"./gff-icon.svg": 152,
	"./pff-icon.svg": 153,
	"./tff-icon.svg": 131,
	"./wff-icon.svg": 154
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2085;



//////////////////
// WEBPACK FOOTER
// ./static/images/icons ^\.\/.*\-icon\.svg$
// module id = 2085
// module chunks = 0